import CustomTooltip from '../../ui/atoms/CustomTooltip';
import { formatValue } from './formatValue';

export const renderFormattedAnswers = (
  answers: any[],
  question: any,
  fromNew?: boolean
) => {
  if (!answers || answers.length === 0) {
    return <span>-</span>; // Fallback for no answers
  }

  // const firstAnswer = formatValue(
  //   question,
  //   answers[0]?.Answer || answers[0] || ''
  // );

  // // Single Entry Case
  // if (answers.length === 1) {
  //   return firstAnswer.length <= charLimit ? (
  //     <span>{firstAnswer}</span> // Single answer within the limit
  //   ) : (
  //     <CustomTooltip label={firstAnswer} arrow placement='top'>
  //       <span>{`${firstAnswer?.slice(0, charLimit)}...`}</span>
  //     </CustomTooltip>
  //   );
  // }

  if (answers.length === 1 && fromNew && !answers[0]?.Answer) {
    return <span>-</span>;
  }

  if (answers.length === 1 && !fromNew && !answers[0]) {
    return <span>-</span>;
  }

  // Multiple Entries Case

  const allAnswers = answers
    .filter((e) => (typeof e === 'string' ? true : e.Active && e.Answer))
    .map((answerObj: any) =>
      formatValue(question, answerObj.Answer || answerObj)
    )
    .join(', ');

  return (
    <CustomTooltip label={allAnswers} arrow placement='top'>
      <span>{allAnswers}</span>
    </CustomTooltip>
  );
  // return firstAnswer.length <= charLimit ? (
  //   <CustomTooltip label={allAnswers} arrow placement='top'>
  //     <span>{`${firstAnswer}, ...`}</span>
  //   </CustomTooltip>
  // ) : (
  //   <CustomTooltip label={allAnswers} arrow placement='top'>
  //     <span>{`${firstAnswer?.slice(0, charLimit)}...`}</span>
  //   </CustomTooltip>
  // );
};
